// Whether the signed-in person may change anything (`routingWrite`, `writesRouting`): from `/api/me`,
// the platform's grants, read once inside `AuthGate`. A Viewer gets false — no editor, no write
// button, no automatic write; the server refuses the rest (403). The pages' payloads say the same
// (`canWrite`), for the code that reads a payload anyway.

import { useRef } from "react";
import { VIEW_ONLY_NOTICE, firstTimeOnly, writesRouting } from "@app/shared";
import { useMe } from "@axny/platform-ui";
import { notify } from "./message";

/** How long the View only toast stays: a few seconds, no button. */
export const VIEW_ONLY_TOAST_MS = 4000;

export function useCanWrite(): boolean {
  const me = useMe();
  return writesRouting(me.data?.authenticated ? me.data.features : undefined);
}

/** A Viewer's refused edit: the View only toast, once per page visit (`firstTimeOnly`); later tries say nothing. */
export function useViewOnlyNotice(): () => void {
  const once = useRef(firstTimeOnly());
  return () => {
    if (once.current()) notify(VIEW_ONLY_NOTICE, undefined, VIEW_ONLY_TOAST_MS);
  };
}
